<template>
    <div class="bill">
        <Head :headInfo='headInfo' @onClickLeft='onBack' />
        <div class="title"><img src="../../../assets/img/b2b/icon_home.png" />{{ $route.query.merchantName }}</div>
        <van-list v-model="loading" :finished="finished" :finished-text="finishText" :immediate-check="false" @load="onLoad">
            <div class="date" v-for="(item, index) in rebateBillList" :key="item.id">
                <div class="head">{{ index }}</div>
                <div class="cont">
                    <div class="item" v-for="(it, idx) in item" :key="idx">
                        <div class="itemLeft">
                            <h3>{{ flowType[it.flowType - 1] }}</h3>
                            <p>{{ it.createTime | formatDate('YYYY-MM-DD hh:mm') }}</p>
                        </div>
                        <span>{{ it.flowType === 2 ? '-' : '+' }}{{ Math.abs(it.flowAmount) | NumFormat }}</span>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</template>
<script>
import Head from '../../common/head'
import { merchantFlowpage } from '../api/api'
import { Toast } from 'vant'
import moment from 'moment'
export default {
    name: 'repayBill',
    components: {
        Head
    },
    data () {
        return {
            headInfo: {
                title: '账单'
            },
            userInfo: {},
            finishText: '数据已加载完毕',
            loading: false,
            finished: false,
            rebateBillCopy: [],
            rebateBillList: [],
            flowType: ['满返', '抵扣', '取消抵扣'],
            form: {
                pageNumber: 1,
                pageSize: 10
            }
        }
    },
    methods: {
        onBack () {
            this.$router.go(-1)
        },
        onLoad () {
            this.form.pageNumber += 1
            this.initData()
        },
        async initData () {
            Toast.loading({
                message: '加载中...',
                duration: 0,
                forbidClick: true
            })
            const { data } = await merchantFlowpage({
                merchantCode: this.$route.query.merchantCode,
                memberCode: this.userInfo.companyCode,
                ...this.form
            })
            this.rebateBillCopy = this.rebateBillCopy.concat(data.records)
            let rebateData = this.rebateBillCopy.reduce((acc, cur) => {
                let createTime = moment(acc.createTime).format('YYYY年MM月')
                if (!acc[createTime]) {
                    acc[createTime] = []
                }
                acc[createTime].push(cur)
                return acc
            }, {})
            Toast.clear()
            this.rebateBillList = rebateData
            this.loading = false
            this.finished = false
            if (this.rebateBillCopy.length >= data.total) {
                this.finished = true
                this.loading = true
            }
            if (data.total < this.form.pageSize) {
                this.finishText = ''
            }
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.initData()
    }
}
</script>
<style lang="scss" scoped>
.bill {
    .title {
        font-size: 28px;
        color: #000;
        padding: 32px;
        /* border-bottom: 1px solid #ededf0; */
        position: relative;
        display: flex;
        align-items: center;
        background: #fff;
        img {
            width: 40px;
            height: 40px;
            margin-right: 24px;
        }
    }
    .date {
        margin-top: 20px;
        background: #fff;
        .head {
            font-size: 28px;
            color: #666;
            padding: 24px 36px;
            border-bottom: 1px solid #ededf0;
        }
        .cont {
            padding-left: 32px;
            .item {
                display: flex;
                justify-content: space-between;
                padding: 32px 32px 32px 0;
                align-items: center;
                &:not(:last-child) {
                    border-bottom: 1px solid #ededf0;
                }
                h3 {
                    font-size: 32px;
                    color: #000;
                    margin-bottom: 12px;
                }
                p {
                    font-size: 24px;
                    color: #666;
                }
                span {
                    font-size: 36px;
                    color: #ff7a45;
                }
            }
        }
    }
}
</style>